module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f89b17149cfcdacfa72f270fe2f90a5f.png";